import { render, staticRenderFns } from "./lotto.vue?vue&type=template&id=339e05b8&scoped=true&"
import script from "./lotto.vue?vue&type=script&lang=js&"
export * from "./lotto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339e05b8",
  null
  
)

export default component.exports